(function(window, templates, BubbleView, highlightDisabler, localizationStrings) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.reviewAnswersConfirmationView = (function() {
      var _superView = BubbleView.create('.review-confirmation-container');
      var _viewTemplate;

      if (templates && templates.question_set_review_confirmation_template) {
         _viewTemplate = templates.question_set_review_confirmation_template;
      } else {
         throw Error('reviewAnswersConfirmationView: Review Answer Confirmation View Template not found.');
      }

      var _containerId = '.controls-container';
      var _continueControlId = '.continue-video-button';
      var _reviewAnswersControlId = '.review-answers-button';

      return {
         getViewMarkup: function(numberCorrectText, percentCorrectText, numberInCorrectText, percentInCorrectText, continueText, reviewText) {
            var context = {
               title: localizationStrings.strings.accessQuizResults,
               alertText: numberCorrectText ? numberCorrectText + ' ' + percentCorrectText + '. ' + numberInCorrectText + ' ' + percentInCorrectText : null,
               numberCorrect: numberCorrectText,
               percentCorrect: percentCorrectText,
               numberInCorrect: numberInCorrectText,
               percentInCorrect: percentInCorrectText,
               continueText: continueText,
               reviewAnswerText: reviewText
            };

            return _viewTemplate(context);
         },
         getContinueControlRef: function() {
            return _continueControlId;
         },
         getReviewControlRef: function() {
            return _reviewAnswersControlId;
         },
         showView: function() {
            _superView.showView(true);
            var $reviewControl = window.$(_containerId).find(_reviewAnswersControlId);
            $reviewControl.focus();
            highlightDisabler.disableHighlights($reviewControl);
         },
         removeView: _superView.removeView,
         updateViewPosition: _superView.updateViewPosition,
         setBottomOffset: _superView.setBottomOffset,
         pointAt: _superView.pointAt
      };
   }());
}(this, window.TSC.templates, window.TSC.BubbleView, window.TSC.highlightDisabler, window.TSC.localizationStrings));
